"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const apiClient_1 = require("../api/apiClient");
const useShortenedLink = (url) => {
    const [shortenedLink, setShortenedLink] = (0, react_1.useState)(url);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const shortenLink = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!url) {
                setError(new Error("URL is missing."));
                return;
            }
            try {
                const response = yield apiClient_1.oldApiClient.post("/short_url", {
                    longUrl: url,
                });
                // Response keys are camelized by the apiClient interceptor.
                setShortenedLink(response.data.shortUrl);
            }
            catch (error) {
                setError(error);
            }
        });
        shortenLink();
    }, [url]);
    return { shortenedLink, error };
};
exports.default = useShortenedLink;
